<template>
    <div class="qesg-dashboard">
        <!-- sidebar -->
        <div :class="['qesg-sidebar', { collapsed: collapsedSidebar }, 'd-flex flex-column', 'border-right border-color-gray-300']">
            <div class="qesg-sidebar__header">
                <b-navbar-brand :to="{ name: 'ContractorProgress',   params: {
                                requestsId: Get_Contractor.company_id,
                            },
                            query: {
                                projectid: $route.query.projectid
                            } }" class="mr-0">
                    <b-img src="/images/QESG_Assessment_basic.svg" width="120" alt="QESG Assessment" />
                </b-navbar-brand>
            </div>
            <div class="qesg-sidebar__body">
                <b-nav v-if="Get_Contractor.company_id" class="w-100 dashboard-nav" vertical>
                    <b-nav-item
                        :to="{
                            name: 'ContractorProgress',
                            params: {
                                requestsId: Get_Contractor.company_id,
                            },
                            query: {
                                projectid: $route.query.projectid
                            }
                        }"
                        class="w-100 mb-2"
                        link-classes="h5 mb-0"
                        :active="$route.name === 'ContractorProgress'"
                        :disabled="disabledLayoutGlobal"
                        >
                        <div class="d-flex align-items-center">
                            <BIconHouseDoorFill font-scale="1" class="mr-3" />
                            {{ $t('진행 현황') }}
                        </div>
                    </b-nav-item>
                    <b-nav-item
                        :to="{
                            name: 'ContractorReport',
                            params: {
                                requestsId: Get_Contractor.company_id,
                            },
                             query: {
                                projectid: $route.query.projectid
                            }
                        }"
                        class="w-100 mb-2"
                        link-classes="h5 mb-0"
                        :active="$route.name === 'ContractorReport'"
                        :disabled="disabledLayoutGlobal"
                        >
                        <div class="d-flex align-items-center">
                            <BIconInfoCircle font-scale="1" class="mr-3" />
                            {{ $t('평가 결과') }}
                        </div>
                    </b-nav-item>
                    <b-nav-item
                        v-if="checkAppEnv() === 'hmc'"
                        :to="{
                            name: 'ContractorActionPlan',
                            params: {
                                requestsId: Get_Contractor.company_id,
                            },
                             query: {
                                projectid: $route.query.projectid
                            }
                        }"
                        class="w-100 mb-2"
                        link-classes="h5 mb-0"
                        :active="$route.name === 'ContractorActionPlan'"
                        :disabled="disabledLayoutGlobal"
                    >
                        <div class="d-flex align-items-center">
                            <BIconFileEarmarkTextFill font-scale="1" class="mr-3" />
                            <span :style="{ fontSize: $i18n.locale === 'en' ? '1.1rem' : '1.25rem' }">
                                {{ $t('개선계획 제출 현황') }}    
                            </span>
                        </div>
                    </b-nav-item>
                </b-nav>
            </div>
            <div class="qesg-sidebar__footer border-top border-color-gray-300 mt-auto py-2 text-right p-3">
                <b-btn variant="light" :aria-label="$t(collapsedSidebar ? '사이드 메뉴 펼치기' : '사이드 메뉴 접기')" @click="toggleSidebar">
                    <b-icon-chevron-bar-left  v-show="!collapsedSidebar" />
                    <b-icon-chevron-bar-right v-show="collapsedSidebar" />
                </b-btn>
            </div>
        </div>
        <!-- lg 미만에서는 펼친 사이드바가 본문을 덮으므로 바깥을 누르면 닫는다 -->
        <div v-if="!collapsedSidebar" class="qesg-sidebar-backdrop d-lg-none" @click="collapsedSidebar = true"></div>

        <!-- body -->
        <div class="position-relative">
            <contractor-navigation-bar
                :isProjectLoaded="disabledLayoutGlobal"
                :collapsedSidebar="collapsedSidebar"
                :projectListError="projectListError"
                @collapseSidebar="toggleSidebar"
                @retry="loadProjects"
                />
            <div :class="['qesg-body position-relative px-md-3 py-md-4 mt-3 mt-md-0', { collapsed: collapsedSidebar }]">
                <b-container fluid class="mb-5">

                    <!-- 에러 Alert 카드 -->
                    <b-row v-if="!isPageDataLoading && showErrorMeassage.state" class="mb-4">
                        <b-col cols="12">
                            <b-card bg-variant="danger" text-variant="white">
                                <div class="d-flex align-items-center">
                                    <BIconInfoCircle class="d-inline-block h3 mb-0 mr-3" />
                                    <div class="d-inline-block mb-0">
                                        <p class="mb-0">{{ $t(showErrorMeassage.message) }}</p>
                                    </div>
                                    <div class="ml-auto">
                                        <b-btn variant="light"
                                            @click="onRecover"
                                            >
                                            {{ $t('다시 시도') }}
                                        </b-btn>
                                    </div>
                                </div>
                            </b-card>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols="12" md="6" class="mb-3 mb-md-0">
                            <div class="d-flex align-items-end justify-content-start h-100">
                                <h1 class="ml-1 mb-0 gray-500" :style="{ fontSize: $i18n.locale === 'en' ? '2.3rem' : '2.5rem' }">{{ $t($route.meta.title_kr) }}</h1>
                            </div>
                        </b-col>
                        <b-col cols="12" md="6">
                            <div class="d-flex align-items-end justify-content-start justify-content-md-end h-100">
                                <div v-show="GET_CONTRACTOR_REQEUST_TIME" class="font-weight-normal mb-0 py-2 px-3 bg-white text-secondary rounded shadow-xs">
                                    {{ $t('최근 조회 시간') }}: {{ requestTime }}
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-container>
                <!-- 자식 화면은 프로젝트 목록·projectid 보정이 끝난 뒤 마운트한다 (보정 전 이중 조회·/undefined/overall 방지) -->
                <router-view
                    v-if="dataLoaded.initial && GET_ProjectList.length"
                    :loadedRequiredData="dataLoaded.initial"
                    @emit-loaded-status="onLoadedStatus"
                    @emit-error-status="onErrorStatus"
                    />
                <b-container v-else-if="dataLoaded.initial && !projectListError" fluid>
                    <b-card class="text-center text-secondary py-4">
                        {{ $t('아직 배정된 프로젝트가 없습니다. 담당자에게 문의해주세요.') }}
                    </b-card>
                </b-container>
            </div>
        </div>
        <back-drop :show="disabledLayoutGlobal" class="positon-relative">
            <template v-if="isPageDataLoading">
                <b-spinner
                    label="Loading..."
                    :style="{ height: '4rem', width: '4rem' }"
                    variant="light"
                    >
                </b-spinner>
            </template>
        </back-drop>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import { mapGetters, mapMutations } from 'vuex';
import { BIconChevronBarLeft, BIconChevronBarRight, BIconHouseDoorFill } from 'bootstrap-vue';
import ContractorNavigationBar from '@shared_components/contractor/components/contractor-navigation-bar';
import backDrop from '@shared_components/common/backdrop.vue';
import {checkAppEnv} from '@shared/utils/common';

const SIDEBAR_COLLAPSED_KEY = 'contractor-sidebar-collapsed';
const isNarrowScreen = () => window.matchMedia('(max-width: 991.98px)').matches;
// lg 미만은 항상 접힌 채 시작하고, lg 이상은 마지막 접힘 상태를 기억한다(이 브라우저 한정 편의)
const initialSidebarCollapsed = () => {
    if (isNarrowScreen()) return true;
    try {
        return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === 'true';
    } catch (error) {
        return false;
    }
};

export default {
    name: 'layout-contractor',
    components: {
        BIconChevronBarLeft,
        BIconChevronBarRight,
        BIconHouseDoorFill,
        ContractorNavigationBar,
        backDrop
    },
    data () {
        return {
            initialLoading: true,
            loadingStatus: false,
            collapseProjectsNavList: true,
            collapsedSidebar: initialSidebarCollapsed(),
            dataLoaded: {
                initial: false,
                content: false
            },
            showErrorMeassage: {
                state: false,
                type: null,
                message: null
            },
            is_inCollapsed_risk_monitoring_nav_group: true,
            projectListError: false
        };
    },
    computed: {
        ...mapGetters('contractor', ['Get_Contractor', 'GET_ProjectList', 'GET_CONTRACTOR_REQEUST_TIME']),
        contractorInfo () {
            return {
                user_id: localStorage.getItem('user_id'),
                company_id: localStorage.getItem('company_id'),
            };
        },
        isPageDataLoading () {
            return Object.values(this.dataLoaded).some(_loaded => _loaded === false);
        },
        disabledLayoutGlobal () {
            return Object.values(this.dataLoaded).some(_loaded => _loaded === false);
        },
        isActiveRiskMonitoringNavGroup() {
            return ['RiskMonitoring','RiskDetailed'].includes(this.$route.name);
        },
        requestTime() {
            return this.GET_CONTRACTOR_REQEUST_TIME
                ? this.$i18n.locale === 'ko'
                    ? dayjs(this.GET_CONTRACTOR_REQEUST_TIME).format('YYYY년 MM월 DD일 HH:mm:ss')
                    : dayjs(this.GET_CONTRACTOR_REQEUST_TIME).format('YYYY-MM-DD HH:mm:ss')
                : null;
        }
    },
    watch: {
        // 좁은 화면에서 메뉴로 화면을 옮기면 사이드바를 닫는다
        '$route.name' () {
            if (isNarrowScreen()) this.collapsedSidebar = true;
        },
        'showErrorMeassage.state' (_state) {
            if (!_state) {
                this.initializeErrorMeassage();
            }
        },
    },
    created () {
        this.dataLoaded.initial = false;
        const _is_empty_contractor_account_store = Object.values(this.Get_Contractor).every(_info => _info === null);
        if (_is_empty_contractor_account_store) {
            const _account = {};
            Object.keys(this.Get_Contractor).forEach(_account_key => {
                const _account_data = localStorage.getItem(_account_key);
                _account[_account_key] = _account_data;
            });

            const _is_empty_contractor_account = Object.values(_account).every(_info => _info === null);
            if (!_is_empty_contractor_account) {
                this.SET_CONTRACTOR_ACCOUNT(_account);
            }
        }
    },
    async mounted () {
        document.body.classList.add('bgray-100');
        await this.loadProjects();
    },
    beforeDestroy () {
        document.body.classList.remove('bgray-100');
        this.SET_PROJECT_LIST([]);
    },
    methods: {
        checkAppEnv,
        ...mapMutations('contractor', ['SET_CONTRACTOR_ACCOUNT', 'SET_PROJECT_LIST']),
        toggleSidebar () {
            this.collapsedSidebar = !this.collapsedSidebar;
            if (isNarrowScreen()) return;
            try {
                localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(this.collapsedSidebar));
            } catch (error) {
                // 저장소를 쓸 수 없으면 기억하지 않는다
            }
        },
        async loadProjects () {
            try {
                this.dataLoaded.initial = false;
                this.projectListError = false;
                const _res_company_project_list = await this.$projectsAxios.get('/accessible');
                if (_res_company_project_list.data) {
                    _res_company_project_list.data.forEach(_project => {
                        if (_project.period && _project.period.includes('_')) {
                            let _active_project_period = _project.period.split('_');
                            _active_project_period[0] = dayjs(_active_project_period[0]).format('YYYY');
                            _active_project_period[1] = _active_project_period[1].replace(/h/gi, '');
                            _project.period_dis = {
                                ko: `${_active_project_period[0]}년 ${_active_project_period[1] === '1' ? '상반기' : '하반기'}`,
                                en: `H${_active_project_period[1]} ${_active_project_period[0]}`,
                                ca: `${_active_project_period[0]}年${_active_project_period[1] === '1' ? '上半年' : '下半年'}`
                            };
                            _project.project_company_num = !_project.project_company_num ? 0 : _project.project_company_num;
                        }
                    });
                }

                this.SET_PROJECT_LIST(_res_company_project_list.data);
                // 목록에 없는 projectid(공유 링크·권한 변경)는 첫 프로젝트로 보정한다
                const _query_projectid = this.$route.query.projectid;
                const _is_valid_projectid = this.GET_ProjectList.some(_project => _project.project_code === _query_projectid);
                const current_project_code = _is_valid_projectid ? _query_projectid : this.GET_ProjectList?.[0]?.project_code;
                // 주소의 원청사 id 가 로그인한 계정과 다르면(다른 계정의 링크) 계정 id 로 맞춘다 — 접근 권한은 서버가 판단
                const _company_id = this.Get_Contractor.company_id;
                const _is_other_requests_id = !!_company_id && String(this.$route.params.requestsId) !== String(_company_id);

                // /requests/:id 로만 들어오면 자식 화면이 없으므로 진행현황으로 보낸다
                if (!this.$route.name || _query_projectid !== current_project_code || _is_other_requests_id) {
                    await this.$router.replace({
                        name: this.$route.name ?? 'ContractorProgress',
                        params: { ...this.$route.params, ...(_is_other_requests_id ? { requestsId: String(_company_id) } : {}) },
                        query: { ...this.$route.query, projectid: current_project_code }
                    });
                    if (_query_projectid && current_project_code && _query_projectid !== current_project_code) {
                        this.$EventBus.$emit('toast-warning', this.$t('프로젝트 변경'), this.$t('요청한 프로젝트를 찾을 수 없거나 권한이 없어 최신 프로젝트로 이동했습니다.'));
                    }
                }
            } catch (error) {
                this.SET_PROJECT_LIST([]);
                this.projectListError = true;
            } finally {
                // 목록이 비었거나 실패하면 자식 화면이 없어 로딩 완료를 알려 줄 곳이 없다
                if (!this.GET_ProjectList.length) this.dataLoaded.content = true;
                this.dataLoaded.initial = true;
            }
        },
        // 현재 query 를 버리지 않고 첫 프로젝트로 복귀한다. 이미 그 화면이면 데이터를 다시 받기 위해 새로고침한다
        onRecover () {
            const _projectid = this.GET_ProjectList?.[0]?.project_code;
            if (this.$route.name === 'ContractorProgress' && this.$route.query.projectid === _projectid) {
                window.location.reload();
                return;
            }
            this.$router.push({
                name: 'ContractorProgress',
                params: { requestsId: this.Get_Contractor.company_id },
                query: { projectid: _projectid }
            }).then(() => this.initializeErrorMeassage()).catch(() => {});
        },
        onLoadedStatus (status) {
            // 새 요청이 시작되면 이전 오류 배너를 걷는다 (오류는 요청 종료 전에 다시 발행됨)
            if (status === false) {
                this.initializeErrorMeassage();
            }
            this.dataLoaded.content = status;
        },
        onErrorStatus ({ status: _error_state, message: _error_msg }) {

            if (process.env.BUILD_NODE_ENV !== 'production') {
                console.log('onErrorStatus ~ ');
                console.log(` ~ _error_state =>  ${_error_state}`);
                console.log(` ~ _error_msg =>  ${_error_msg}`);
            }
            
            // 화면 언어를 바꿔도 바로 반영되게 원문 키를 두고 렌더할 때 $t 로 번역한다
            const _error_obj_set = {
                'not-allowed': '이 프로젝트를 볼 권한이 없거나 존재하지 않는 프로젝트입니다.',
                'not-recognized': '데이터를 불러오지 못했습니다. 잠시 후 다시 시도해주세요.'
            };

            this.showErrorMeassage = {
                state: _error_state,
                type: _error_msg,
                message: _error_obj_set[_error_msg] || _error_obj_set['not-recognized']
            };
        },
        initializeErrorMeassage () {
            this.showErrorMeassage = {
                state: false,
                type: null,
                message: null
            };
        }
    }
};
</script>

<style lang="scss">
</style>
